import type { LocaleDict } from './i18n/types';

/** The label keys `metricLabel` (lib/resourceHistoryChart) reads, filled from the settings
 *  dictionary. ONE mapping for the ring strip and the history modal alike, so a resource cannot be named
 *  one thing on its dial and another in its own history. */
export function resourceMetricStrings(t: LocaleDict): Record<string, string> {
  return {
    usageCpu: t.settings.diagnosticCpu,
    usageRam: t.settings.diagnosticMemory,
    usageDisk: t.settings.diagnosticDisk,
    usageIo: t.settings.diagnosticIo,
    usageNetwork: t.settings.diagnosticNetwork,
  };
}
